import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IconSizesEnum, IIcon } from '../icon/icon.component';

type NoteStyle = 'success' | 'info' | 'alert';

enum NoteIconsEnum {
  success = 'success',
  info = 'info',
  alert = 'alert',
}

@Component({
  selector: 'i2g-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoteComponent implements OnInit {
  @Input() noteStyle: NoteStyle = 'info';
  @Input() message: string;

  leftIcon: IIcon;

  constructor() {}

  ngOnInit() {
    this.leftIcon = {
      name: `i2g-note-${NoteIconsEnum[this.noteStyle]}`,
      size: IconSizesEnum.small,
    };
  }
}
